import { type CreateCampaignInputType } from '@shelflix/schemas/campaign/create';
import { create } from 'zustand';

interface CampaignFormStore {
  formData: Partial<CreateCampaignInputType>;
  setFormData: (data: Partial<CreateCampaignInputType>) => void;
  resetForm: () => void;
}

export const useCampaignFormStore = create<CampaignFormStore>((set) => ({
  formData: {},
  setFormData: (data) => set((state) => ({ formData: { ...state.formData, ...data } })),
  resetForm: () => set({ formData: {} }),
}));
